// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main-container {
  margin-top: 10px;
  padding: 0px 14px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
}
#main-container .container-left-buttons,
#main-container .container-center-inputs,
#main-container .container-right-buttons {
  width: 100%;
  display: flex;
  gap: 5px;
}
#main-container .container-left-buttons button:disabled,
#main-container .container-center-inputs button:disabled,
#main-container .container-right-buttons button:disabled {
  cursor: not-allowed !important;
}
#main-container .container-left-buttons {
  gap: 5px;
}
#main-container .container-center-inputs {
  justify-content: center;
  align-items: center;
}
#main-container .container-center-inputs .container-field-search {
  width: 100%;
  text-align: center;
}
#main-container .container-center-inputs .container-field-search mat-form-field {
  width: 100%;
}
#main-container .container-center-inputs .container-field-search mat-form-field mat-icon {
  cursor: pointer;
}
#main-container .width-80percent {
  width: 80% !important;
}
#main-container .container-right-buttons {
  flex-direction: row-reverse;
}

@media screen and (max-width: 768px) {
  #main-container {
    display: flex;
    flex-direction: column;
    gap: 1em;
  }
  #main-container .container-left-buttons {
    grid-area: new;
    justify-content: center;
  }
  #main-container .container-right-buttons {
    grid-area: export;
    justify-content: center;
  }
  #main-container .container-center-inputs {
    grid-area: search;
    overflow: auto;
    flex-direction: column;
  }
  #main-container .container-center-inputs .container-field-search {
    width: 90%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/utils/shared/components/generic-table-header/generic-table-header.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;AACJ;AACI;;;EAGI,WAAA;EACA,aAAA;EACA,QAAA;AACR;AACQ;;;EACI,8BAAA;AAGZ;AACI;EACI,QAAA;AACR;AAEI;EACI,uBAAA;EACA,mBAAA;AAAR;AAEQ;EACI,WAAA;EACA,kBAAA;AAAZ;AACY;EACI,WAAA;AAChB;AACgB;EACI,eAAA;AACpB;AAKI;EACI,qBAAA;AAHR;AAMI;EACI,2BAAA;AAJR;;AASA;EACI;IACI,aAAA;IACA,sBAAA;IACA,QAAA;EANN;EAQM;IACI,cAAA;IACA,uBAAA;EANV;EASM;IACI,iBAAA;IACA,uBAAA;EAPV;EAUM;IACI,iBAAA;IACA,cAAA;IACA,sBAAA;EARV;EAUU;IACI,UAAA;EARd;AACF","sourcesContent":["#main-container {\r\n    margin-top: 10px;\r\n    padding: 0px 14px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: baseline;\r\n    width: 100%;\r\n\r\n    .container-left-buttons,\r\n    .container-center-inputs,\r\n    .container-right-buttons {\r\n        width: 100%;\r\n        display: flex;\r\n        gap: 5px;\r\n\r\n        button:disabled {\r\n            cursor: not-allowed !important;\r\n        }\r\n    }\r\n\r\n    .container-left-buttons {\r\n        gap: 5px;\r\n    }\r\n\r\n    .container-center-inputs {\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        .container-field-search {\r\n            width: 100%;\r\n            text-align: center;\r\n            mat-form-field {\r\n                width: 100%;\r\n\r\n                mat-icon {\r\n                    cursor: pointer;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .width-80percent {\r\n        width: 80% !important;\r\n    }\r\n\r\n    .container-right-buttons {\r\n        flex-direction: row-reverse;\r\n    }\r\n}\r\n\r\n// responsive design\r\n@media screen and (max-width: 768px) {\r\n    #main-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 1em;\r\n\r\n        .container-left-buttons {\r\n            grid-area: new;\r\n            justify-content: center;\r\n        }\r\n\r\n        .container-right-buttons {\r\n            grid-area: export;\r\n            justify-content: center;\r\n        }\r\n\r\n        .container-center-inputs {\r\n            grid-area: search;\r\n            overflow: auto;\r\n            flex-direction: column;\r\n\r\n            .container-field-search {\r\n                width: 90%;\r\n            }\r\n        }\r\n\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
